var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
import { EventObject } from "./EventObject";
import { Utility } from "./Utils";
var EMPTY_PICKER_CSS_CLASS = "__empty";
var SearchPickerChoices = /** @class */ (function (_super) {
    __extends(SearchPickerChoices, _super);
    function SearchPickerChoices(container, options, isMobile) {
        var _this = _super.call(this) || this;
        _this.container = container;
        _this.options = options;
        _this.selected = [];
        _this.keepActive = false;
        _this.isActive = false;
        _this.pendingBackstroke = [];
        _this.isMobile = isMobile;
        _this.sizerElm = document.getElementById('__srchpicker-sizer');
        if (_this.sizerElm) {
            _this.sizerElmText = _this.sizerElm.childNodes[0];
        }
        _this.setup();
        return _this;
    }
    SearchPickerChoices.prototype.addChoice = function (item) {
        var id = this.selected.push(item) - 1;
        //insert new choice item into DOM
        this.container.insertBefore(this.$renderChoice(item, id), this.inputJsElmWrap);
        this.inputElm.value = '';
        this.scaleSearchField();
        this.checkEmptiness();
    };
    SearchPickerChoices.prototype.removeChoice = function (item) {
        for (var i = 0; i < this.selected.length; i++) {
            if (this.selected[i].id === item.id) {
                this.selected.splice(i, 1);
                this.removeChoiceElement(item.id.toString());
                this.scaleSearchField();
                this.$notifyEvent('choiceRemoved', item);
                this.checkEmptiness();
                return;
            }
        }
    };
    SearchPickerChoices.prototype.removeAll = function () {
        var length = this.selected.length;
        for (var i = 0; i < length; i++) {
            this.removeChoice(this.selected[0]);
        }
    };
    SearchPickerChoices.prototype.getSearchText = function () {
        return this.inputElm.value;
    };
    SearchPickerChoices.prototype.setSearchText = function (val) {
        this.inputElm.value = val;
        this.checkEmptiness();
    };
    SearchPickerChoices.prototype.focus = function () {
        if (!this.canSelectMoreChoices()) {
            var length_1 = this.container.childNodes.length;
            if (length_1 > 1) {
                var choiceNode = this.container.childNodes.item(length_1 - 2);
                choiceNode.focus();
                choiceNode.click();
            }
            return;
        }
        this.onFocus();
        this.inputElm.focus();
    };
    SearchPickerChoices.prototype.getHeight = function () {
        return this.container.offsetHeight;
    };
    SearchPickerChoices.prototype.canSelectMoreChoices = function () {
        if (this.inputForbidden)
            return false;
        if (this.options.maxSelectedChoices <= 0)
            return true;
        return this.selected.length < this.options.maxSelectedChoices;
    };
    SearchPickerChoices.prototype.setAutocompleteText = function (text) {
        if (!this.shouldUpdateAutoComplete || this.isMobile) {
            return;
        }
        if (text && this.inputElm.value.length) {
            this.removeAutocompleteText();
            var selStart = this.inputElm.value.length, inputValue = this.escapeRegexp(this.inputElm.value);
            if (text.toUpperCase().search(inputValue.toUpperCase()) === 0) {
                this.inputElm.value = text;
            }
            else {
                this.inputElm.value += " (" + text + ")";
            }
            var selEnd = this.inputElm.value.length;
            this.inputElm.setSelectionRange(selStart, selEnd);
        }
        this.scaleSearchField();
    };
    SearchPickerChoices.prototype.removeAutocompleteText = function () {
        if (this.inputElm.selectionStart) {
            this.inputElm.value = this.inputElm.value.substring(0, this.inputElm.selectionStart);
        }
    };
    Object.defineProperty(SearchPickerChoices.prototype, "forbidInput", {
        set: function (val) {
            if (val) {
                this.inputForbidden = true;
                this.disableInput(true);
            }
            else {
                this.inputForbidden = false;
                this.disableInput(false);
            }
        },
        enumerable: true,
        configurable: true
    });
    SearchPickerChoices.prototype.escapeRegexp = function (text) {
        return text.replace(/[-[\]{}()*+?.,\\^$|#\s]/g, '\\$&');
    };
    SearchPickerChoices.prototype.setup = function () {
        this.applyTemplate();
        this.bindEvents();
        this.scaleSearchField();
    };
    SearchPickerChoices.prototype.scaleSearchField = function () {
        if (!this.canSelectMoreChoices()) {
            this.disableInput(true);
            return;
        }
        else {
            this.disableInput(false);
        }
        var placeholderText = this.selected.length > 0 ? '' : this.options.placeholder;
        this.inputElm.placeholder = placeholderText;
        this.ensureSizerElement();
        this.sizerElmText.nodeValue = this.inputElm.value || placeholderText;
        var w = this.sizerElm.offsetWidth + 20;
        this.inputElm.style.width = w + 'px';
        if (this.inputElm.style.display !== 'block')
            this.inputElm.style.display = 'block';
    };
    SearchPickerChoices.prototype.disableInput = function (disable) {
        if (disable) {
            this.inputElm.style.display = 'none';
            this.keepActive = false;
            this.onBlur();
        }
        else {
            this.inputElm.style.display = 'block';
        }
    };
    SearchPickerChoices.prototype.ensureSizerElement = function () {
        if (!this.sizerElm) {
            var div = document.createElement('div');
            var styleBlock = "position:absolute; left: -1000px; top: -1000px;";
            var styles = ['font-size', 'font-style', 'font-weight', 'font-family', 'line-height', 'text-transform', 'letter-spacing'];
            for (var i = 0; i < styles.length; i++) {
                var style = styles[i];
                styleBlock += style + ":" + Utility.getCssPropertyValue(this.inputElm, style) + ";";
            }
            div.id = '__srchpicker-sizer';
            div.style.cssText = styleBlock;
            this.sizerElmText = document.createTextNode('');
            div.appendChild(this.sizerElmText);
            document.body.appendChild(div);
            this.sizerElm = div;
        }
    };
    SearchPickerChoices.prototype.bindEvents = function () {
        var _this = this;
        this.container.onclick = function () {
            _this.onClick();
        };
        this.inputElm.onblur = function (e) {
            //prevent input blur when we are focusing on picker container, as it should behave as input
            if ((e.relatedTarget && e.relatedTarget === _this.container)
                || document.activeElement === _this.container /*IE*/) {
                _this.inputElm.focus();
                return;
            }
            _this.onBlur();
        };
        this.inputElm.onfocus = function () {
            _this.onFocus();
        };
        this.inputElm.onkeyup = function (e) {
            _this.onKeyUp(e);
        };
        this.inputElm.oninput = function (e) {
            // IE 11 может выбросить событие input при установке плейсхолдера в элемент
            if (document.activeElement !== e.target) {
                return;
            }
            _this.onInput(e);
        };
        this.inputElm.onkeydown = function (e) {
            _this.onKeyDown(e);
        };
    };
    SearchPickerChoices.prototype.onClick = function () {
        this.onFocus();
        if (!this.canSelectMoreChoices())
            return;
        if (this.options.minLengthToSearch == 0 && this.isActive) {
            this.clearBackstroke();
            this.$notifyEvent('search', this.getSearchText());
        }
    };
    SearchPickerChoices.prototype.onKeyUp = function (evt) {
        switch (evt.keyCode) {
            case 46:
            case 8:
                if (this.backstrokeLength < 1 && this.selected.length > 0) {
                    this.keydownBackstroke();
                }
                else if (!this.pendingBackstroke.length && this.canSelectMoreChoices()) {
                    this.clearHilightedChoice();
                    //this.$notifyEvent('search', this.getSearchText());
                }
                this.scaleSearchField();
                break;
            case 13:
                if (this.inputElm.value) {
                    evt.preventDefault();
                }
                this.$notifyEvent('enter', evt);
                break;
            case 27:
                this.$notifyEvent('escape', evt);
                break;
            case 9:
            case 38:
            case 40:
            case 16:
            case 17:
            case 224: // mac
            case 91:
            case 92:
            default:
                break;
        }
    };
    SearchPickerChoices.prototype.onInput = function (evt) {
        this.shouldUpdateAutoComplete = this.prevInputTextLength <= this.inputElm.value.length;
        this.prevInputTextLength = this.inputElm.value.length;
        if (this.canSelectMoreChoices()) {
            this.clearBackstroke();
            this.scaleSearchField();
            this.$notifyEvent('search', this.getSearchText());
        }
        this.checkEmptiness();
    };
    SearchPickerChoices.prototype.onKeyDown = function (evt) {
        switch (evt.keyCode) {
            case 46:
            case 8: //backspace & del
                this.backstrokeLength = this.inputElm.value.length;
                break;
            case 9:
                this.$notifyEvent('tab', evt);
                break;
            case 13:
            case 16:
            case 17:
                if (this.inputElm.value) {
                    evt.preventDefault();
                }
                break;
            case 38:
                evt.preventDefault();
                this.shouldUpdateAutoComplete = true;
                this.$notifyEvent('arrowUp', evt);
                break;
            case 40:
                evt.preventDefault();
                this.shouldUpdateAutoComplete = true;
                this.$notifyEvent('arrowDown', evt);
                break;
            case 35: // left, right, home, end
            case 36:
            case 37:
            case 39:
                // возможный сброс выделения с текста автодополнения
                if (this.inputElm.selectionStart !== this.inputElm.selectionEnd) {
                    this.onInput(evt);
                }
                break;
            default:
                if (!this.canSelectMoreChoices()) {
                    evt.preventDefault();
                }
                else {
                    this.scaleSearchField();
                    //перебрасываем набор текста в инпут
                    if (document.activeElement !== this.inputElm) {
                        this.inputElm.focus();
                        this.onFocus();
                    }
                }
                break;
        }
    };
    SearchPickerChoices.prototype.onRemoveChoiceClick = function (choice) {
        var id = Utility.getAttribute(choice, 'data-id');
        var item = this.getSelectedChoiceById(id);
        if (item != null)
            this.removeChoice(item);
    };
    SearchPickerChoices.prototype.clearHilightedChoice = function () {
        if (this.highlightedChoice) {
            Utility.removeClass(this.highlightedChoice, 'highlighted');
            this.highlightedChoice = null;
        }
    };
    SearchPickerChoices.prototype.clearBackstroke = function () {
        if (this.pendingBackstroke.length) {
            for (var _i = 0, _a = this.pendingBackstroke; _i < _a.length; _i++) {
                var li = _a[_i];
                Utility.removeClass(li, 'search-choice-focus');
            }
            this.pendingBackstroke = [];
        }
    };
    SearchPickerChoices.prototype.keydownBackstroke = function () {
        if (this.pendingBackstroke.length) {
            for (var _i = 0, _a = this.pendingBackstroke; _i < _a.length; _i++) {
                var li = _a[_i];
                var id = Utility.getAttribute(li, 'data-id');
                var selectedItem = this.getSelectedChoiceById(id);
                if (selectedItem != null) {
                    this.removeChoice(selectedItem);
                    //li.blur();
                }
            }
            this.clearBackstroke();
            //this.$notifyEvent('blur')
            //this.inputElm.focus();
        }
        else {
            var items = this.container.getElementsByTagName("li");
            var lastChoice = null;
            for (var i = 0; i < items.length; i++) {
                if (Utility.hasClass(items[i], 'search-choice'))
                    lastChoice = items[i];
            }
            this.pendingBackstroke[0] = lastChoice;
            if (this.pendingBackstroke[0] != null)
                Utility.addClass(this.pendingBackstroke[0], "search-choice-focus");
        }
    };
    SearchPickerChoices.prototype.onBlur = function () {
        var _this = this;
        this.inFocus = false;
        if (!this.isActive)
            return;
        setTimeout(function () {
            if (!_this.keepActive && !_this.inFocus) {
                Utility.removeClass(_this.container, 'active'); // active in ul root elem
                _this.isActive = false;
                _this.clearBackstroke();
                _this.$notifyEvent('blur');
            }
        }, 10);
    };
    SearchPickerChoices.prototype.onFocus = function () {
        var _this = this;
        this.inFocus = true;
        if (this.isActive)
            return;
        Utility.addClass(this.container, 'active'); // active in ul root elem
        this.isActive = true;
        setTimeout(function () {
            if (_this.inFocus && (document.activeElement === _this.inputElm ||
                document.activeElement === _this.container ||
                _this.canSelectMoreChoices() && Utility.hasClass(document.activeElement, 'search-choice'))) {
                _this.$notifyEvent('focus');
            }
        }, 10);
    };
    SearchPickerChoices.prototype.removeChoiceElement = function (id) {
        var choices = this.container.getElementsByTagName('li');
        for (var i = 0; i < choices.length; i++) {
            if (Utility.hasClass(choices[i], 'search-choice')
                && Utility.getAttribute(choices[i], 'data-id') === id) {
                choices[i].parentElement.removeChild(choices[i]);
                return;
            }
        }
    };
    SearchPickerChoices.prototype.applyTemplate = function () {
        Utility.addClass(this.container, EMPTY_PICKER_CSS_CLASS);
        this.inputJsElmWrap = document.createElement('li');
        this.inputJsElmWrap.className = 'search-field';
        this.inputElm = document.createElement('input');
        this.inputElm.type = 'text';
        this.inputElm.placeholder = this.options.placeholder;
        this.inputElm.autocomplete = 'off';
        this.inputJsElmWrap.appendChild(this.inputElm);
        this.container.appendChild(this.inputJsElmWrap);
    };
    SearchPickerChoices.prototype.$renderChoice = function (item, index) {
        var _this = this;
        var choice = document.createElement('li');
        choice.tabIndex = 0; //important to receive keyboard events
        choice.className = 'search-choice';
        choice.setAttribute('data-id', item.id.toString());
        if (this.options.maxSelectedChoices == 1) {
            Utility.addClass(choice, "sole-choice");
        }
        choice.onclick = function (e) {
            if (Utility.hasClass(e.target, 'search-choice-close')) {
                _this.onRemoveChoiceClick(choice);
                return;
            }
            Utility.addClass(choice, "search-choice-focus");
            if (e.metaKey || e.ctrlKey) {
                Utility.addClass(choice, "search-choice-focus");
                _this.pendingBackstroke.push(choice);
            }
            else if (e.shiftKey) {
                var newChoices = _this.getChoicesRange(choice, _this.pendingBackstroke[_this.pendingBackstroke.length - 1]);
                for (var _i = 0, newChoices_1 = newChoices; _i < newChoices_1.length; _i++) {
                    var ch = newChoices_1[_i];
                    Utility.addClass(ch, "search-choice-focus");
                    _this.pendingBackstroke.push(ch);
                }
            }
            else {
                _this.pendingBackstroke.forEach(function (el) {
                    if (el !== choice) {
                        Utility.removeClass(el, "search-choice-focus");
                    }
                });
                _this.pendingBackstroke = [choice];
            }
            //e.preventDefault();
            e.stopPropagation();
            if (_this.inputElm.style.display !== "none") {
                _this.inputElm.focus();
            }
        };
        choice.onkeyup = function (e) {
            _this.onKeyUp(e);
        };
        choice.onkeydown = function (e) {
            _this.onKeyDown(e);
        };
        choice.onblur = function (e) {
            _this.onBlur();
        };
        choice.onfocus = function (e) {
            _this.onFocus();
        };
        choice.appendChild(this.options.choiceRenderer(item, this.options.maxSelectedChoices == 1));
        return choice;
    };
    SearchPickerChoices.prototype.getSelectedChoiceById = function (id) {
        for (var i = 0; i < this.selected.length; i++) {
            if (this.selected[i].id.toString() === id)
                return this.selected[i];
        }
        return null;
    };
    SearchPickerChoices.prototype.getChoicesRange = function (choice1, choice2) {
        var nodesToAdd = [], inInterval = false;
        for (var k = 0, e = this.container.childNodes.item(0); k < this.container.childNodes.length; ++k) {
            if (e === choice1 || e === choice2) {
                nodesToAdd.push(e);
                inInterval = !inInterval;
                if (!inInterval)
                    break;
            }
            else if (inInterval && Utility.hasClass(e, "search-choice")) {
                nodesToAdd.push(e);
            }
            e = e.nextSibling;
        }
        return nodesToAdd;
    };
    SearchPickerChoices.prototype.checkEmptiness = function () {
        if (this.inputElm.value == "" && this.selected.length == 0) {
            Utility.addClass(this.container, EMPTY_PICKER_CSS_CLASS);
        }
        else {
            Utility.removeClass(this.container, EMPTY_PICKER_CSS_CLASS);
        }
    };
    return SearchPickerChoices;
}(EventObject));
export { SearchPickerChoices };
